import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function CashoutOnboardingProcessingInfoModal({ onClose }) {
  const { t } = useTranslation(null, { useSuspense: false });

  return (
    <div
      id="cashout-tax-requirements"
      className="phoenix-simple-dialog-view modal member-diamonds-cash-confirm show"
      aria-hidden="false"
    >
      <div className="modal-backdrop fade in" />
      <div className="modal-dialog">
        <div className="modal-content modal-content-sm">
          <div>
            <div className="modal-header">
              <h4>{t('cashout_onboarding_before_cashout')}</h4>
              <hr className="below-header-breakline" />
            </div>
            <div className="modal-body">
              <div className="row">
                <p className="col-xs-12 cash-out-text">
                  {t('cashout_onboarding_processing_info')}
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group">
                <div className="col-xs-12">
                  <button
                    type="button"
                    className="btn btn-primary btn-half btn-cashout-continue"
                    onClick={onClose}
                  >
                    {t('cashout_got_it')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CashoutOnboardingProcessingInfoModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
